module.exports = __webpack_public_path__ + "img/comment_1_4.b0784e4c.jpg";